import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { Group, Stack, Title } from '@mantine/core';
import SampleSearchBar from 'apps/Lab/Samples/common/SampleSearchBar';

import { Header } from 'common';

import { handleBulkDensitySearchResult } from '../utils/sampleSearchUtils';

import BulkDensityDetails from './BulkDensityDetails';

import styles from 'apps/Lab/Samples/Overview/Container.module.css';

const LabBulkDensityBarcodeContainer = () => {
  const { t } = useTranslation();
  const { barcode } = useParams<{ barcode: string; sample_uuid?: string }>();
  const [focus, setFocus] = useState(false);

  const triggerSearchBarFocus = useCallback(() => {
    setFocus(true);
  }, []);

  return (
    <Stack gap="0">
      <Header
        title={
          <Group gap="xs">
            <Title order={3} style={{ whiteSpace: 'pre-wrap' }}>
              {`${t('sampleBarcode')}: ${barcode}`}
            </Title>
          </Group>
        }
      >
        <SampleSearchBar
          className={styles.SampleSearchInput}
          autofocus={focus}
          onSearch={() => setFocus(false)}
          handleSearchResult={handleBulkDensitySearchResult}
        />
      </Header>
      <Stack>
        <BulkDensityDetails barcode={barcode} onSubmissionSuccess={triggerSearchBarFocus} />
      </Stack>
    </Stack>
  );
};

export default LabBulkDensityBarcodeContainer;
